import { escapeFilterValue } from "./escape-filter-value";

export function buildFilterCondition(
  field: string,
  operator: "==" | "!=" | ">=" | "<=" | ">" | "<",
  value: string | number | boolean
): string {
  if (typeof value === "string") {
    return `${field}${operator}"${escapeFilterValue(value)}"`;
  }
  return `${field}${operator}${value}`;
}
